<template>
  <section>
    <div>
      <hr>
      <b-tabs
        v-model="tabIndex"
        small
        content-class="mt-3"
        @activate-tab="loadTabResults"
      >
        <b-tab
          ref="listTab"
          title="Lista"
        >
          <ResultTable
            @submit-form="submitForm"
            @load-whole-table="loadWholeTable"
            @sort-changed="onSort"
            @exclude-rows="submitExcludeRows"
          />
        </b-tab>
        <b-tab
          title="Räckvidd och frekvens"
          :disabled="!hasSelection"
        >
          <Reach @onSearchReach="searchReach" />
        </b-tab>
        <b-tab
          v-if="config_ShowProgramConsumptionTab"
          title="Konsumtionsmönster"
          :disabled="!hasSelection"
        >
          <ProgramConsumption ref="programConsumptionComponent" />
        </b-tab>
        <template v-slot:tabs-end>
          <div
            v-if="tabIndex === 0"
            class="sumexportbtnswrapper"
          >
            <b-button
              variant="primary"
              size="sm"
              class="mr-2"
              :disabled="measuresInTable.length === 0"
              @click="showOrHideSumInTable"
            >
              {{ sumVisible ? "Göm Summering" : "Visa Summering" }}
            </b-button>
            <b-button
              size="sm"
              variant="success"
              @click="exportResult"
            >
              <b-icon icon="arrow-repeat" />
              Exportera
            </b-button>
          </div>
        </template>
      </b-tabs>
    </div>
    <ConfirmDialog
      :dialog-id="confirmDialogId"
      :dialog-vertical-center="true"
      dialog-title="Justera din sökning för Konsumtionsmönster"
      :dialog-message="tabDialogMessage"
    >
      <template #modal-footer>
        <b-button
          size="sm"
          variant="primary"
          class="px-4"
          @click="closeDialog"
        >
          Ok
        </b-button>
      </template>
    </ConfirmDialog>
  </section>
</template>

<script>
import ResultTable from './ResultTable.vue';
import Reach from './Reach.vue';
import ProgramConsumption from './ProgramConsumption.vue';
import { mapActions } from 'vuex';
import { bus } from '../../../main';
import ConfirmDialog from "@/components/Shared/Dialogs/ConfirmDialog"

import { downloadFile } from '../../../assets/js/api.js';

export default {
  name: 'Result',
  components: {
    ResultTable,
    Reach,
    ProgramConsumption,
    ConfirmDialog,
  },
  
  data() {
    return {
      tabIndex: 0,
      confirmDialogId: "change-tab-dialog",
      tabDialogMessage: ""
    };
  },
  computed: {
    sumVisible() {
      return this.$store.getters[`searchResults/getSumVisible`];
    },
    hasSelection() {
      return this.$store.state.reachApiBody.payload.title_codes.length > 0;
    },
    measuresInTable() {
      return this.$store.getters[`searchResults/getMeasuresInTable`];
    },
    hasExcludedRows() {
      return this.$store.getters[`searchResults/getHasExcludedRows`];
    }
  },
  mounted() {
    bus.$on('searching', () => {
      if (this.$refs.listTab !== undefined) {
        this.$refs.listTab.activate();
        this.$store.commit('reachApiBody/emptyTitleCodes');
        this.$store.commit('searchResults/unselectAll');
      }
    });
    //get back to listTab when change periodtype
    bus.$on('changePeriod', () => {
      if (this.$refs.listTab !== undefined) {
        this.$refs.listTab.activate();
      }
    });
  },
  methods: {
    ...mapActions(['searchReach']),
    onSort(item) {
      this.$emit('sort-only', item);
    },
    submitForm(item) {
      this.$emit('submit-form', item);
    },
    loadWholeTable(load) {
      this.$emit('load-whole-table', load);
    },
    submitExcludeRows() {
      this.$emit('exclude-rows');
    },
    async loadTabResults(newTabIndex, prevTabIndex, bvEvent) {
      if(newTabIndex === prevTabIndex) return
      if (newTabIndex === 1) {
        this.searchReach()
      }
      if (newTabIndex === 2) {
        if (this.$store.getters['consumptionResults/consumptionResultsQuery'].uniqueDatesInPeriod.length > 7) {
          this.tabDialogMessage = 'Du får max välja 7 dagar som period för att visa Konsumtionsmönster. Välj en ny period och tryck "Kör"'
          bvEvent.preventDefault()
          this.$bvModal.show(this.confirmDialogId)
        } else if (this.$store.getters['consumptionResults/consumptionResultsQuery'].measures.length < 1) {
          this.tabDialogMessage = 'Välj mått av typen räckvidd (Reach) i Målgrupper / Mått för att visa Konsumtionsmönster. Lägg till räckvidds-mått och tryck "Kör"'
          bvEvent.preventDefault()
          this.$bvModal.show(this.confirmDialogId)
        } else if (this.$store.getters['consumptionApiBody/consumptionApiBody'].selectedPeriod === "publicationperiod") {
          this.tabDialogMessage = 'Var god välj "Konsumtionsperiod" i Period för att visa Konsumtionsmönster. Ditt nuvarande val är "Publiceringsperiod".'
          bvEvent.preventDefault()
          this.$bvModal.show(this.confirmDialogId)
        } else if (this.$store.getters['consumptionApiBody/consumptionApiBody'].title_codes.length > 7) {
          this.tabDialogMessage = "Du får max välja 7 stycken program för Konsumtionsmönster. Avmarkera rader i result-listan och försök igen."
          bvEvent.preventDefault()
          this.$bvModal.show(this.confirmDialogId)
        } else {
          // Load the consumption tab
          this.tabIndex = newTabIndex
          this.$refs.programConsumptionComponent.onThisTabClick();
          await this.$store.dispatch('consumptionResults/initialize')
        }
      } else {
        this.tabIndex = newTabIndex
      }
    },
    closeDialog() {
      this.$bvModal.hide(this.confirmDialogId)
    },
    async exportResult() {
      try {
        let payload = {...this.$store.state.searchApiBody};
        await downloadFile('QueryData/DownloadExport', payload);
      } catch (error) {
        console.error('Failed to export results:', error);
        // Show error to user
        this.$bvToast.toast('Ett fel uppstod vid export av data. Försök igen senare.', {
          title: 'Export misslyckades',
          variant: 'danger',
          solid: true
        });
      }
    },
    showOrHideSumInTable(){
      this.$store.commit('searchResults/setSumVisible', !this.sumVisible);
    },
  },
};
</script>
